import axios from 'axios';
const API_BASE_URL = 'https://file.marcaone.com/api';
const api = axios.create({
  baseURL: API_BASE_URL,
  validateStatus: () => true
});
export const dashboardClient = {
  async login(username, password) {
    const response = await api.post('/auth/login', { username, password });
    if (response.status === 200) {
      localStorage.setItem('admin_token', response.data.token);
      return { success: true, data: response.data };
    }
    return { success: false, error: response.data.error };
  },
  async getLocations() {
    const token = localStorage.getItem('admin_token');
    const response = await api.get('/locations', {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (response.status === 200) {
      return { success: true, data: response.data.locations };
    }
    return { success: false, error: response.data.error };
  },
  async getFilesAsAdmin(locationId) {
    const token = localStorage.getItem('admin_token');
    const response = await api.get(`/files/${locationId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (response.status === 200) {
      return { success: true, data: response.data.files };
    }
    return { success: false, error: response.data.error };
  },
  logout() {
    localStorage.removeItem('admin_token');
  }
};
export default dashboardClient;

dashboardClient.createLocation = async function(name, pin, description) {
  const token = localStorage.getItem('admin_token');
  const response = await api.post('/locations', {
    name,
    pin,
    description
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (response.status === 201) {
    return { success: true, data: response.data };
  }
  return { success: false, error: response.data.error };
};

// NUEVO: borrar un archivo individual
dashboardClient.deleteFile = async function(locationId, fileId) {
  const token = localStorage.getItem('admin_token');
  const response = await api.delete(`/files/${locationId}/${fileId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (response.status === 200) {
    return { success: true };
  }
  return { success: false, error: response.data.error };
};

// NUEVO: eliminar una ubicacion completa
dashboardClient.deleteLocation = async function(locationId) {
  const token = localStorage.getItem('admin_token');
  const response = await api.delete(`/locations/${locationId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (response.status === 200) {
    return { success: true };
  }
  return { success: false, error: response.data.error };
};

// NUEVO: descargar un archivo
dashboardClient.downloadFile = async function(locationId, fileId, originalName) {
  const token = localStorage.getItem('admin_token');
  try {
    const response = await api.get(`/files/${locationId}/download/${fileId}`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob'
    });
    if (response.status !== 200) {
      return { success: false, error: 'No se pudo descargar' };
    }
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', originalName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (e) {
    return { success: false, error: e.message };
  }
};
